import axios from "axios";
import { Constants } from "../utils/Constants";

export const login = (email, password) => {
    return axios.post(`${Constants.baseUrl}/login`, { email, password });
}

export const forgot = (data) => {
    return axios.post(`${Constants.baseUrl}/esqueceu-senha`, data);
}

export const reenviarCodigo = (data) => {
    return axios.post(`${Constants.baseUrl}/reenviar-codigo`, data);
}

export const verificarCodigo = (data) => {
    return axios.post(`${Constants.baseUrl}/verificar-codigo`, data);
}

export const reset = (data) => {
    return axios.post(`${Constants.baseUrl}/recuperar-senha`, data);
}

export const signUp = (data) => {
    return axios.post(`${Constants.baseUrl}/sign-up`, data);
}

export const primeiroAcesso = (data) => {
    return axios.patch(`${Constants.baseUrl}/primeiro-acesso`, data);
}

export const getUser = () => {
    return axios.get(`${Constants.baseUrl}/perfil`);
}
